import Main from './main.vue';
import { isVNode } from '../../utils'


let instance;
let calkBackList = [];
let seed = -1;
let LocationConstructor = Vue.extend(Main);
let selectCityObj = null
let locateObj = null
try {
    selectCityObj = JSON.parse(localStorage.selectCityObj)
} catch (e) {
    selectCityObj = null
}
try {
    locateObj = JSON.parse(localStorage.locateObj)
} catch (e) {
    locateObj = null
}
let currentLocation = locateObj && locateObj.cityName && locateObj.tcCityId && locateObj.elCityId ? locateObj : {
    isSuccess: false,//res.latitude&&res.longitude,
    latitude: "",//	纬度	Number	-	-
    longitude: "",//	经度	Number	-	-
    speed: '',//	速度	Number	-	只有微信H5/微信小程序/外部H5
    accuracy: '',//	位置的精确度	Number	-	只有微信H5/微信小程序/外部H5
    altitude: '',//	高度	Number	-	只有百度小程序支持/外部H5
    provName: '上海',//	省份名称	String	-	-
    cityName: '上海',//	城市名称	String	-	-
    tcProvId: '25',//	同程省份Id	Number	-	-
    tcCityId: '321',//	同程城市Id	Number	-	-
    elCityId: '0201',//	艺龙城市Id	String	-	不支持同程APP
    threeCode: "SHA"
}
const Location = function (...options) {
    let data = options && options[0] && options[0].data || null
    let calkBack = options && options[0] && options[0].callback || null
    currentLocation.action = 'init'
    calkBack({
        currentLocation,
        historyLocation: locateObj,
        historySelectCity: selectCityObj
    })
    calkBackList.push(calkBack);
    if (seed !== -1 && (!data || (data && !data.retry))) {
        return
    }
    _locationTrack(currentLocation)
    setTimeout(() => {
        console.log('ui location AllBridge.getLocation prams:', instance.appCacheType)
        console.log('ui location AllBridge.getLocation realPrams:', { cacheType: instance.appCacheType || '3' })
        window.AllBridge.getLocation(
            { cacheType: instance.appCacheType || '3' }
        ).then((res) => {
            console.log('ui location AllBridge.getLocation res:', res)
            currentLocation = res
            currentLocation.action = 'update'
            _locationTrack(currentLocation)
            calkBackList.forEach(calkBack => {
                calkBack({
                    currentLocation,
                    historyLocation: locateObj,
                    historySelectCity: selectCityObj
                })
            })
            /**
             * 1、如果没有历史定位城市
             * 2、有历史定位城市，并且没有历史选择城市，当前定位城市和历史定位城市不一样
             * 3、有理数选择城市，但是超过了12个小时有效期，并且选择的城市和定位城市不一样
             */
            if (!locateObj || (!selectCityObj && locateObj.cityName !== res.cityName && !res.type)
                || (selectCityObj && res.cityName !== selectCityObj.cityName && localStorage.storageExpire === 'true' && !res.type)) {
                locateObj = res
                instance.cityName = currentLocation.cityName
                // 根据background参数判断是否直接走确认逻辑
                if (instance.background) {
                    instance.switchFn();
                } else {
                    instance.visible = true
                }
            }
        }).catch((e) => {
            // console.log('location', e)
        })
    }, 100)
    instance = new LocationConstructor({
        data: data,
        methods: {
            closeFn() {
                this.visible = false
                calkBackList.forEach(calkBack => {
                    currentLocation.action = 'cancel'
                    _locationTrack(currentLocation)
                    localStorage.removeItem('locateObj')
                    calkBack({
                        currentLocation,
                        historyLocation: locateObj,
                        historySelectCity: selectCityObj
                    })
                })
            },
            switchFn() {
                this.visible = false
                currentLocation.action = 'confrim'
                _locationTrack(currentLocation)
                calkBackList.forEach(calkBack => {
                    calkBack({
                        currentLocation,
                        historyLocation: locateObj,
                        historySelectCity: selectCityObj
                    })
                })
                currentLocation.isSuccess = true
                localStorage.locateObj = JSON.stringify(currentLocation)
            }
        }
    });

    if (isVNode(instance.message)) {
        instance.$slots.default = [instance.message];
        instance.message = null;
    } else {
        delete instance.$slots.default;
    }
    seed++
    instance.$mount();
    document.body.appendChild(instance.$el);
    return instance;
};
function _locationTrack(currentLocation) {
    window.AllBridge
        .allEventTrack({
            category: "alle_page",
            action: `all_Location_${currentLocation.action}_event`,
            value: {
                "isDefault": currentLocation.isSuccess ? 1 : 0,
                "latLon": `${currentLocation.longitude},${currentLocation.latitude}`,
                "nCity": `${currentLocation.provName},${currentLocation.cityName}`
            }
        })
}


export default Location;